import type { StripeSEPAPayment } from "@js/types/payments";

import { PaymentMethodMaskedIBAN } from "../../payment-method-masked-iban";

import styles from "./styles.module.scss";

type StripeSEPAInlineProps = {
  paymentMethod: StripeSEPAPayment;
};

export const StripeSEPAInline = ({ paymentMethod }: StripeSEPAInlineProps) => {
  return (
    <div className={styles.stripeCreditCard}>
      <PaymentMethodMaskedIBAN
        last4={paymentMethod.method.last4}
        country={paymentMethod.method.country}
      />
    </div>
  );
};
